import React from "react";
import { cn } from "../../lib/utils";

const variants = {
  default: "bg-secondary text-secondary-foreground",
  outline: "border border-border text-foreground",
  success: "bg-emerald-500/15 text-emerald-400 border border-emerald-500/30",
  warning: "bg-amber-500/15 text-amber-400 border border-amber-500/30",
  danger: "bg-red-500/15 text-red-400 border border-red-500/30",
  accent: "bg-accent/15 text-accent-foreground border border-accent/40",
  lime: "bg-accent text-accent-foreground",
};

export function Badge({ className, variant = "default", ...props }) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-sm px-2 py-0.5 text-[11px] font-mono font-medium",
        variants[variant],
        className
      )}
      {...props}
    />
  );
}
